<ng-container>
  <div class="mb-6 page-padding-x" id="section-committee-updates">
    <div class="flex flex-row items-center justify-between">
      <div class="flex items-center">
        <h2 id="heading-committee-updates">Committee Updates</h2>
      </div>
      <div class="flex flex-row justify-end items-center gap-6 [&>div:not(:first-child)]:border-l-2">
        <a class="btn btn-primary" [routerLink]="['/committees']" id="btn-view-committees">
          {{ viewCommitteesButtonLabel }}
        </a>
      </div>
    </div>
  </div>

  <ng-container>
    <div *ngIf="loading" class="flex justify-center" id="loading-spinner-committee-updates">
      <mat-progress-spinner mode="indeterminate" diameter="50">
      </mat-progress-spinner>
    </div>

    <app-update-scroller *ngIf="!loading && committees" [title]="'New Updates'" [updateCount]="committees.length"
      id="scroller-committee-updates">
      <a *ngFor="let committee of committees" [routerLink]="['/committees', committee.committeeCode]"
        [id]="'card-committee-updates-' + committee.committee">
        <app-update-scroller-card [title]="committee.committee" [description]="committee.description"
          [id]="'card-committee-updates-' + committee.committee + '-container'">
          <div headerLeft name="date" id="committee-update-date-{{committee.committee}}">
            {{committee.lastModifiedDate | dateFormat}}
          </div>
          <app-button-email-committee-members
            headerRight
            [committeeCode]="committee.committeeCode"
            [displayAsButton]="false"
            id="btn-email-committee-{{committee.committeeCode}}">
          </app-button-email-committee-members>
        </app-update-scroller-card>
      </a>
    </app-update-scroller>

    <div *ngIf="!loading && committees?.length == 0"
      class="p-5 ml-10 font-bold bg-white rounded-lg page-padding-s w-80 shadow-cardShadow h-36 card-size"
      id="message-no-committee-updates">
      There are no new updates for your committees at this time.
    </div>
  </ng-container>
</ng-container>
